/* eslint-disable jsx-a11y/anchor-is-valid */

import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

const MemberType: FC = () => {
	const navigate = useNavigate()

	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault()
		navigate('/plans')
	}

	return (
		<div
			className="menu-item px-5"
			data-kt-menu-trigger="hover"
			data-kt-menu-placement="left-start"
			data-kt-menu-flip="bottom">
			<a href="#" className="menu-link px-5" onClick={handleClick}>
				<span className="menu-title position-relative">Member Type</span>
			</a>
		</div>
	)
}

export { MemberType }
